<template>
    <div id="accordion">
        <DxAccordion :data-source="accordionData" item-title-template="itemTitle" @selection-changed="onAccordionSelectionChanged">
            <template #itemTitle="{ data }">
                <div class="header"><b>{{ data.title }}</b></div>
            </template>
            <template #item="{ data }">
                <DxDataGrid v-if="data.title === 'Utilizatori'" :data-source="dsUtilizatori" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedUtilizatori" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxToolbar>
                        <DxGridItem>
                            <template #default>
                                <DxButton icon="add" type="success" @click="showAddUserPopup" />
                            </template>
                        </DxGridItem>
                    </DxToolbar>
                    <DxColumn data-field="Username" :allowEditing="false" />
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Agenti'" :data-source="dsAgenti" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedAgenti" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxFilterRow :visible="true" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxColumn data-field="Cod" />
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Tipuri de Documente'" :data-source="dsTipuri" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedDocumente" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="UserID" :visible="false" />
                    <DxColumn data-field="Cod" :visible="false" />
                    <DxColumn data-field="CategorieID" caption="Categorie">
                        <DxLookup :data-source="dsCategorii" value-expr="Id" display-expr="Nume"></DxLookup>
                    </DxColumn>
                    <DxColumn data-field="Nume" />

                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Gestiuni'" :data-source="dsGestiuni" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedGestiuni" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="Cod" />
                    <DxColumn data-field="Nume" />
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <template v-if="data.isModule">
                    <div class="module-section-label">Meniuri</div>
                    <DxDataGrid :data-source="getModuleMeniuri(data.modulId)" key-expr="ID"
                        :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                        :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                        :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                        :on-row-updated="(e) => onRowUpdatedModuleMeniu(e)" :on-editor-preparing="onEditor">
                        <DxEditing mode="cell" :allow-updating="true" />
                        <DxPaging :page-size="10" :page-index="1" />
                        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                        <DxFilterRow :visible="true" />
                        <DxColumn data-field="Nume" :allowEditing="false" :allow-filtering="true" />
                        <DxColumn data-field="Explicatie" :allowEditing="false" :allow-filtering="true" />
                        <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true" :allow-filtering="false" />
                        <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                        <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                        <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    </DxDataGrid>
                    <div class="module-section-label" style="margin-top: 14px">Drepturi Custom</div>
                    <DxDataGrid :data-source="getModuleDrepturi(data.modulId)" key-expr="ID"
                        :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                        :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                        :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                        :on-row-updated="(e) => onRowUpdatedModuleCustom(e)" :on-editor-preparing="onEditor">
                        <DxEditing mode="cell" :allow-updating="true" />
                        <DxPaging :page-size="10" :page-index="1" />
                        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                        <DxFilterRow :visible="true" />
                        <DxColumn data-field="Nume" :allowEditing="false" :allow-filtering="true" />
                        <DxColumn data-field="Explicatie" :allowEditing="false" :allow-filtering="true" />
                        <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true" :allow-filtering="false" />
                        <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                        <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                        <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    </DxDataGrid>
                </template>

                <DxDataGrid v-if="data.title === 'Categorii Comenzi'" :data-source="dsCategoriiComenzi" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedCategoriiComenzi" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="Nume" :allow-filtering="true" />
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Categorii Produse'" :data-source="dsCategoriiProduse" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedCategoriiProduse" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="ClasaID" :allow-filtering="true" caption="Clasa">
                        <DxLookup :data-source="dsClase" value-expr="ID" display-expr="Nume" />
                    </DxColumn>
                    <DxColumn data-field="Nume" :allow-filtering="true" />
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Capitole'" :data-source="dsCapitole" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedCapitole" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="Nume" :allow-filtering="true" />
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Categorii Documente'" :data-source="dsCategoriiDocumente"
                    key-expr="ID" :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedCategoriiDocumente" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="Nume" :allow-filtering="true" />
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>


            </template>
        </DxAccordion>

    </div>

    <DxPopupAdd :visible.sync="isModalVisible" />

    <DxPopup :visible.sync="isPopupUtilizatoriVisible" title="Adăugare Utilizator în Rol" :width="450" :height="250">
        <div style="padding: 10px;">
            <v-select v-model="selectedUserId" :items="dsUtilizatoriNeasignati" item-title="Username" item-value="ID"
                variant="outlined" placeholder="Selectați utilizatorul..." label="Utilizator" />
            <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 20px;">
                <DxButton text="Salvează" type="success" width="100" @click="onSaveUtilizatorPopup" />
                <DxButton text="Închide" type="danger" width="100" @click="onCancelUtilizatorPopup" />
            </div>
        </div>
    </DxPopup>

</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem, DxPopup } from 'devextreme-vue/popup';
import DxAccordion from 'devextreme-vue/accordion';
import DxTagBox from 'devextreme-vue/tag-box';
import DxCheckBox from 'devextreme-vue/check-box';
import DxForm, { DxItem as DxFormItem } from 'devextreme-vue/form';
import DxSlider, { DxTooltip, DxLabel } from 'devextreme-vue/slider';
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxLookup,
    DxItem as DxGridItem
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import notify from 'devextreme/ui/notify';
import AUTH_DrepturiUtilizatori from '@/services/AUTH/AUTH_DrepturiUtilizatori';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import AUTH_DrepturiRoluri from '@/services/AUTH/AUTH_DrepturiRoluri';
import AUTH_DrepturiModule from '@/services/AUTH/AUTH_DrepturiModule';
import UserService from '@/services/Administrare/UserService';
import AUTH_Users from '@/services/AUTH/AUTH_Users';
export default defineComponent({
    components: {
        DxToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxLabel,
        DxPopupAdd,
        DxPopup,
        DxToolbarItem,
        DxAccordion,
        DxTagBox,
        DxCheckBox,
        DxSlider,
        DxTooltip,
        DxForm,
        DxFormItem,
        DxEditing,
        DxLookup,
        DxGridItem
    },

    data() {
        return {
            accordionData: [
                { title: "Utilizatori" },
                { title: "Agenti" },
                { title: "Capitole" },
                { title: "Categorii Comenzi" },
                { title: "Categorii Documente" },
                { title: "Categorii Produse" },
                { title: "Gestiuni" },
                { title: "Tipuri de Documente" },
            ] as any[],
            dsCategorii: {} as ODataStore,
            dsGestiuni: [] as any[],
            dsAgenti: [] as any[],
            dsTipuri: [] as any[],
            dsMeniuri: [] as any[],
            dsMeniuriCustom: [] as any[],
            dsCategoriiComenzi: [] as any[],
            dsCategoriiProduse: [] as any[],
            dsCapitole: [] as any[],
            dsUtilizatori: [] as any[],
            dsClase: {} as ODataStore,
            dsCategoriiDocumente: [] as any[],
            isModalVisible: false,
            isPopupUtilizatoriVisible: false,
            dsUtilizatoriNeasignati: [] as any[],
            selectedUserId: null as any,
            multiple: false,
            dataGridRef: ref<DxDataGrid | null>(null),
        };
    },
    props: {
        rolId: { type: [Number, String, null], default: null },
    },
    computed: {
        normalizedRolId(): string | null {
            if (this.rolId === null || this.rolId === undefined) return null;
            return String(this.rolId);
        },
    },
    watch: {
        normalizedRolId: {
            immediate: true,
            handler(id) {
                this.getAgenti(id);
                this.getTipuri(id);
                this.getGestiuni(id);
                this.getMeniuri(id);
                this.getMeniuriCustom(id);
                this.getCategoriiComenzi(id);
                this.getCategoriiProduse(id);
                this.getCapitole(id);
                this.getCategoriiDocumente(id);
                this.getUtilizatori(id);

            },
        },
    },
    methods: {
        createODataContext() {
            this.dsCategorii = new ODataStore({
                url: AppSetting.API_Url_DocumenteOdata + 'DOC_Categorii',
                key: 'ID',
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                    };
                },
            }
            )
            this.dsClase = new ODataStore({
                url: AppSetting.API_Url + 'PRO_Clase',
                key: 'ID',
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                    };
                },
            }
            )
        },
        onEditor(e) {
            if (['Citeste', 'Modifica', 'Sterge'].includes(e.dataField)) {
                const hasRight = e.row?.data?.HasRight === true;
                e.editorOptions = e.editorOptions || {};
                e.editorOptions.disabled = !hasRight;
                if (!hasRight && e.value === true) {
                    e.setValue(false);
                }
            }
        },
        onRowUpdatedAgenti(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const rolId = this.normalizedRolId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!rolId || !agentId) {
                console.warn('Lipsesc userId/agentId', { rolId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    rolId,
                    agentId,
                    tip: 'COM_Agenti',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiRoluri.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiRoluri.updateRoluri(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiRoluri.delete(rolId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedDocumente(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const rolId = this.normalizedRolId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!rolId || !agentId) {
                console.warn('Lipsesc userId/agentId', { rolId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    rolId,
                    agentId,
                    tip: 'DOC_Tipuri',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiRoluri.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiRoluri.updateRoluri(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiRoluri.delete(rolId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedGestiuni(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const rolId = this.normalizedRolId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!rolId || !agentId) {
                console.warn('Lipsesc userId/agentId', { rolId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    rolId,
                    agentId,
                    tip: 'GES_Gestiuni',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiRoluri.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiRoluri.updateRoluri(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiRoluri.delete(rolId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedMeniuri(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const rolId = this.normalizedRolId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!rolId || !agentId) {
                console.warn('Lipsesc userId/agentId', { rolId, agentId });
                return;
            }


            if (hasRight && !rightId) {
                const body = {
                    rolId,
                    agentId,
                    tip: 'Meniu',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiRoluri.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiRoluri.updateRoluri(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiRoluri.delete(rolId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },

        onRowUpdatedMeniuriCustom(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const rolId = this.normalizedRolId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!rolId || !agentId) {
                console.warn('Lipsesc rolId/agentId', { rolId, agentId });
                return;
            }


            if (hasRight && !rightId) {
                const body = {
                    rolId,
                    agentId,
                    tip: 'Custom',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiRoluri.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiRoluri.updateRoluri(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiRoluri.delete(rolId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedCategoriiComenzi(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const rolId = this.normalizedRolId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!rolId || !agentId) {
                console.warn('Lipsesc rolId/agentId', { rolId, agentId });
                return;
            }


            if (hasRight && !rightId) {
                const body = {
                    rolId,
                    agentId,
                    tip: 'PRO_CategoriiComenzi',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiRoluri.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiRoluri.updateRoluri(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiRoluri.delete(rolId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedCategoriiProduse(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const rolId = this.normalizedRolId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!rolId || !agentId) {
                console.warn('Lipsesc userId/agentId', { rolId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    rolId,
                    agentId,
                    tip: 'PRO_Categorii',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiRoluri.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiRoluri.updateRoluri(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiRoluri.delete(rolId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedCapitole(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const rolId = this.normalizedRolId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!rolId || !agentId) {
                console.warn('Lipsesc userId/agentId', { rolId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    rolId,
                    agentId,
                    tip: 'DOC_Capitole',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiRoluri.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiRoluri.updateRoluri(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiRoluri.delete(rolId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedCategoriiDocumente(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const rolId = this.normalizedRolId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!rolId || !agentId) {
                console.warn('Lipsesc userId/agentId', { rolId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    rolId,
                    agentId,
                    tip: 'DOC_Categorii',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiRoluri.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiRoluri.updateRoluri(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiRoluri.delete(rolId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedUtilizatori(e: any) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const rolId = this.normalizedRolId;
            const userId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            if (!rolId || !userId) {
                console.warn('Lipsesc rolId/userId', { rolId, userId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    userId,
                    rolId,
                };
                AUTH_DrepturiUtilizatori.saveRol(body)
                    .then((response) => {
                        notify('Utilizator adăugat în rol!', 'success', 1000);
                        const newId = response?.data?.rightId ?? response?.data?.ID;
                        if (newId) {
                            row.RightId = newId;
                            const idx = (this.$refs.dataGridRef as any).instance.getRowIndexByKey(userId);
                            if (idx >= 0) {
                                (this.$refs.dataGridRef as any).instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
                    .catch(console.error);
            }

            if (!hasRight && rightId) {
                AUTH_DrepturiUtilizatori.deleteRoluriUtilizatori(userId, rolId, rightId)
                    .then(() => {
                        notify('Utilizator eliminat din rol!', 'success', 1000);
                        row.RightId = null;
                        const idx = (this.$refs.dataGridRef as any).instance.getRowIndexByKey(userId);
                        if (idx >= 0) {
                            (this.$refs.dataGridRef as any).instance.cellValue(idx, 'RightId', null);
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la eliminare!', 'error', 1000);
                        (this.$refs.dataGridRef as any).instance.cellValue((e.component as any).getRowIndexByKey(userId), 'HasRight', true);
                    });
            }
        },
        getAgenti(rolId: string) {
            if (!rolId) return;
            AUTH_DrepturiRoluri.getAgenti(encodeURIComponent(rolId))
                .then(r => this.dsAgenti = r.data ?? [])
                .catch(console.error);
        },
        getTipuri(entityId: string) {
            if (!entityId) return;
            AUTH_DrepturiRoluri.getTipuri(encodeURIComponent(entityId))
                .then(r => this.dsTipuri = r.data ?? [])
                .catch(console.error);
        },
        getGestiuni(entityId: string) {
            if (!entityId) return;
            AUTH_DrepturiRoluri.getGestiuni(encodeURIComponent(entityId))
                .then(r => this.dsGestiuni = r.data ?? [])
                .catch(console.error);
        },
        getMeniuri(entityId) {
            if (!entityId) return;
            AUTH_DrepturiRoluri.getMeniuri(encodeURIComponent(entityId))
                .then(r => this.dsMeniuri = r.data.filter((item: any) => item.Meniu === true || item.Meniu === 1))

                .catch((e: Error) => {
                    console.log(e)
                });
        },
        getMeniuriCustom(entityId) {
            if (!entityId) return;
            AUTH_DrepturiRoluri.getMeniuriCustom(encodeURIComponent(entityId))
                .then(r => this.dsMeniuriCustom = r.data.filter((item: any) => item.Meniu === false || item.Meniu === 0))

                .catch((e: Error) => {
                    console.log(e)
                });
        },
        getCategoriiComenzi(userId: string) {
            if (!userId) return;
            AUTH_DrepturiRoluri.getCategoriiComenzi(encodeURIComponent(userId))
                .then(r => this.dsCategoriiComenzi = r.data ?? [])
                .catch(console.error);
        },
        getCategoriiProduse(userId: string) {
            if (!userId) return;
            AUTH_DrepturiRoluri.getCategoriiProduse(encodeURIComponent(userId))
                .then(r => this.dsCategoriiProduse = r.data ?? [])
                .catch(console.error);
        },
        getCapitole(userId: string) {
            if (!userId) return;
            AUTH_DrepturiRoluri.getCapitole(encodeURIComponent(userId))
                .then(r => this.dsCapitole = r.data ?? [])
                .catch(console.error);
        },
        getCategoriiDocumente(userId: string) {
            if (!userId) return;
            AUTH_DrepturiRoluri.getCategoriiDocumente(encodeURIComponent(userId))
                .then(r => this.dsCategoriiDocumente = r.data ?? [])
                .catch(console.error);
        },
        loadModules() {
            AUTH_DrepturiModule.getModule()
                .then((r: any) => {
                    const staticItems = [
                        { title: "Utilizatori" },
                        { title: "Agenti" },
                        { title: "Capitole" },
                        { title: "Categorii Comenzi" },
                        { title: "Categorii Documente" },
                        { title: "Categorii Produse" },
                        { title: "Gestiuni" },
                        { title: "Tipuri de Documente" },
                    ];
                    const moduleItems = (r.data ?? []).map((m: any) => ({
                        title: m.Nume,
                        isModule: true,
                        modulId: m.ID,
                    }));
                    this.accordionData = [...staticItems, ...moduleItems];
                })
                .catch(console.error);
        },
        onAccordionSelectionChanged(e: any) {
            const rolId = this.normalizedRolId;
            if (!rolId) return;
            for (const item of (e.addedItems ?? [])) {
                if (item.isModule) {
                    if (this.dsMeniuri.length === 0) this.getMeniuri(rolId);
                    if (this.dsMeniuriCustom.length === 0) this.getMeniuriCustom(rolId);
                }
            }
        },
        getModuleMeniuri(modulId: string): any[] {
            return this.dsMeniuri.filter((x: any) => x.ModulID === modulId);
        },
        getModuleDrepturi(modulId: string): any[] {
            return this.dsMeniuriCustom.filter((x: any) => x.ModulID === modulId);
        },
        onRowUpdatedModuleMeniu(e: any) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const rolId = this.normalizedRolId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;
            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;
            if (!rolId || !agentId) return;
            if (hasRight && !rightId) {
                AUTH_DrepturiRoluri.save({ rolId, agentId, tip: 'Meniu', citeste, modifica, sterge })
                    .then(() => {
                        notify('Drept adăugat cu succes!', 'success', 1000);
                        this.getMeniuri(rolId);
                    });
                return;
            }
            if (hasRight && rightId) {
                AUTH_DrepturiRoluri.updateRoluri(rightId, { Citeste: citeste, Modifica: modifica, Sterge: sterge })
                    .then(() => notify('Drept actualizat!', 'success', 1000))
                    .catch(() => notify('Eroare la actualizare!', 'error', 1000));
                return;
            }
            if (!hasRight && rightId) {
                AUTH_DrepturiRoluri.delete(rolId, agentId, rightId)
                    .then(() => { notify('Drept șters cu succes!', 'success', 1000); this.getMeniuri(rolId); })
                    .catch(() => notify('Eroare la ștergere!', 'error', 1000));
            }
        },
        onRowUpdatedModuleCustom(e: any) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const rolId = this.normalizedRolId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;
            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;
            if (!rolId || !agentId) return;
            if (hasRight && !rightId) {
                AUTH_DrepturiRoluri.save({ rolId, agentId, tip: 'Custom', citeste, modifica, sterge })
                    .then(() => {
                        notify('Drept adăugat cu succes!', 'success', 1000);
                        this.getMeniuriCustom(rolId);
                    });
                return;
            }
            if (hasRight && rightId) {
                AUTH_DrepturiRoluri.updateRoluri(rightId, { Citeste: citeste, Modifica: modifica, Sterge: sterge })
                    .then(() => notify('Drept actualizat!', 'success', 1000))
                    .catch(() => notify('Eroare la actualizare!', 'error', 1000));
                return;
            }
            if (!hasRight && rightId) {
                AUTH_DrepturiRoluri.delete(rolId, agentId, rightId)
                    .then(() => { notify('Drept șters cu succes!', 'success', 1000); this.getMeniuriCustom(rolId); })
                    .catch(() => notify('Eroare la ștergere!', 'error', 1000));
            }
        },
        getUtilizatori(rolId: string) {
            if (!rolId) return;
            AUTH_DrepturiRoluri.getUtilizatori(encodeURIComponent(rolId))
                .then(r => this.dsUtilizatori = r.data ?? [])
                .catch(console.error);
        },
        onClick() {
            this.isModalVisible = true;
        },
        onRefreshClick() {
            this.createODataContext();
            this.getAgenti();
            this.getTipuri();
            this.getGestiuni();
            this.getMeniuri();
            this.getCategoriiProduse();
            this.getCategoriiDocumente();
            this.getUtilizatori();
            notify('Datele au fost actualizate cu succes!', 'success', 1000)
        },
        showAddUserPopup() {
            this.isPopupUtilizatoriVisible = true;
            this.selectedUserId = null;
            AUTH_Users.get()
                .then(r => this.dsUtilizatoriNeasignati = r.data ?? [])
                .catch(console.error);
        },
        onSaveUtilizatorPopup() {
            if (!this.selectedUserId) {
                notify('Vă rugăm selectați un utilizator!', 'warning', 2000);
                return;
            }
            const rolId = this.normalizedRolId;
            if (!rolId) return;

            const body = {
                userId: this.selectedUserId,
                rolId,
            };
            AUTH_DrepturiUtilizatori.saveRol(body)
                .then(() => {
                    this.isPopupUtilizatoriVisible = false;
                    notify('Utilizator adăugat cu succes!', 'success', 2000);
                    this.getUtilizatori(rolId);
                })
                .catch(error => {
                    console.error(error);
                    notify('Eroare la adăugarea utilizatorului!', 'error', 2000);
                });
        },
        onCancelUtilizatorPopup() {
            this.isPopupUtilizatoriVisible = false;
        },
    },
    mounted() {
        this.createODataContext();
        this.loadModules();
        this.getAgenti();
        this.getTipuri();
        this.getGestiuni();
        this.getMeniuri();
        this.getMeniuriCustom();
        this.getCategoriiProduse();
        this.getCapitole();
        this.getCategoriiDocumente();
        this.getUtilizatori();
        this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
    },
});
</script>
<style scoped>
.module-section-label {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #94a3b8;
    padding: 4px 0 6px 0;
}
</style>
